import React from 'react'
import numeral from 'numeral'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, withHandlers } from 'recompose'
import { FormattedMessage } from 'react-intl'

import {fetchingState} from '../helpers/hocs.js'
import {get, getCount} from '../store/reducers/persons/list.js'

import {getExternalPartnersList} from "../selectors/externalpartners.js";
import {getExternalPartners} from "../store/reducers/externalpartners/list.js";

import Link from './../components/Link'
import Button from './../components/Button'

const ExternalPartners = ({ items = [], total = 0, length = 0, fetching, loadMore }) => {
	console.log(items);
  return (
    <div className='ExternalPartners'>
      <div className='Container Container_light'>
        <div className='ExternalPartners__header'>
          Социально ответственные бренды, которые совместно с Business for Charity
          помогают фондам и некоммерческим организациям.
        </div>
        <span className="ExternalPartners__table">
        {items.map((externalpartner, i) => {
	      //при наличие alias будет включен в ссылку на лот, если нет остается id
		  let alias = externalpartner._id
		  if(externalpartner.alias)
          {
            alias = externalpartner.alias
          }
          return (
		  <Link key={i} className='Link Link_light ExternalPartners__Link' to={'/externalpartners/' + alias}> {}
            <span className='Head ExternalPartners__head'>{ externalpartner.title }</span>
            {<div className={
				(((externalpartner.title === 'Даблби') || (externalpartner.title === 'Нетология')) && (numeral(externalpartner.sumOfExternalPayments).format('0,0') == 0)) 
				? 'Text ExternalPartners__total ExternalPartners__total-orange' 
				: 'Text ExternalPartners__total'}>
				
				{(numeral(externalpartner.sumOfExternalPayments).format('0,0') == 0) 
				?((((externalpartner.title === 'Даблби') || (externalpartner.title === 'Нетология')) && (numeral(externalpartner.sumOfExternalPayments).format('0,0') == 0)) 
					? 'started' 
					: (((externalpartner.title === 'Bionova') && (numeral(externalpartner.sumOfExternalPayments).format('0,0') == 0)) 
						? '773 265₽' 
						: (((externalpartner.title === 'Boardriders') && (numeral(externalpartner.sumOfExternalPayments).format('0,0') == 0)) 
							? '100 000₽' 
							: 'coming soon')
					  )
				 ) 
				: (numeral(externalpartner.sumOfExternalPayments).format('0,0') + '₽')}
            </div>}
          </Link>
		  
        )})}
        </span>
        { ((total - items.length) > 0) && (<Button loading={fetching} onClick={loadMore}>
          Посмотреть еще
        </Button>)}
      </div>
    </div>

  )
}

const mapStateToProps = state => ({
  ...getExternalPartnersList(state),
  currentLocale: state.intl.locale
})

const mapDispatchToProps = dispatch => bindActionCreators({ getExternalPartners }, dispatch)
const mergeProps = (state, { getExternalPartners}, { fetchingWrap, ...props }) => ({
  ...props,
  ...state,
  getExternalPartners: (offset, noLoader) => noLoader ? getExternalPartners(offset) : fetchingWrap(getExternalPartners.bind(this, offset))
})

// TODO: Добавить лоадер
export default compose(
  fetchingState(),
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withHandlers({
    loadMore: ({ length = 0, getExternalPartners, fetching }) => async e => {
      e && e.preventDefault()
      if (fetching) return
      await getExternalPartners(length)
    }
  }),
  lifecycle({
    componentDidMount () {
      this.props.getExternalPartners(0, false)
    }
  })
)(ExternalPartners)



// WEBPACK FOOTER //
// ./src/containers/ExternalPartners.jsx